<div class="flex items-center mx:w-[440px] sm:w-full sm:pr-4">
    <div class="customer_title sm:ml-4">{{'CUSTOMER' | translate}}</div>
    <div class="flex flex-1 items-center w-full customer-name" nz-button nz-popover [nzPopoverTitle]="undefined" (click)="togglePopover()" [nzPopoverContent]="contentTemplate" nzPopoverTrigger="click" [nzPopoverVisible]="isShow">
        <div class="flex-1 customer truncate" [class.customer-error]="hasSelectedCustomerIssue()" [attr.title]="selectedCustomerName+'_'+selectedCustomerCode">{{selectedCustomerName}}_{{selectedCustomerCode}}</div>
        <div class="cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M11.9981 15.498L6.39453 9.89453L7.10169 9.18738L11.9981 14.0839L16.8945 9.18738L17.6017 9.89453L11.9981 15.498Z"
                    fill="black" />
            </svg>
        </div>
    </div>

    <ng-template #contentTemplate>
        <div class="customer_content mt-[14px] mb-[14px]">
            <div class="flex-between w-full mb-[8px]">
                <span class="font18-w700">{{'CUSTOMERS' | translate}} ({{items.length}}/{{total}})</span>
                <div class="cursor-pointer" (click)="isShow=false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M19.9495 4.75964L19.2407 4.05078L12.0001 11.2786L4.75964 4.05078L4.05078 4.75964L11.2786 12.0001L4.05078 19.2407L4.75964 19.9495L12.0001 12.7217L19.2407 19.9495L19.9495 19.2407L12.7217 12.0001L19.9495 4.75964Z"
                            fill="black" />
                    </svg>
                </div>
    
            </div>
            <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                <input nz-input [placeholder]="'SOLD_TO_NAME' |translate" [(ngModel)] ="customerKeyword" (keydown.enter)="onEnter()" />
            </nz-input-group>
            <ng-template #suffixTemplateInfo>
                <div class="cursor-pointer" (click)="onClear()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M16.6474 6.64795L17.3524 7.35295L12.7139 11.9999L17.3534 16.6469L16.6484 17.3519L12.0014 12.7124L7.35344 17.3519L6.64844 16.648L11.2889 11.9999L6.64944 7.35195L7.35344 6.64795L12.0014 11.2874L16.6474 6.64795Z"
                            fill="black" />
                    </svg>
                </div>
                <div class="cursor-pointer ml-[24px]" (click)="onEnter()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M21.35 18.65L14.25 11.5375C14.7375 10.625 15 9.6 15 8.5C15 4.9125 12.0875 2 8.5 2C4.9125 2 2 4.9125 2 8.5C2 12.0875 4.9125 15 8.5 15C9.6 15 10.625 14.725 11.5375 14.25L18.65 21.3625C19.0875 21.8 19.6375 22.0125 20.175 22.0125C20.6625 22.0125 21.125 21.8375 21.475 21.4875C22.225 20.7375 22.175 19.4625 21.35 18.65ZM3 8.5C3 5.4625 5.4625 3 8.5 3C11.5375 3 14 5.4625 14 8.5C14 11.5375 11.5375 14 8.5 14C5.4625 14 3 11.5375 3 8.5ZM20.775 20.775C20.55 21 20.2875 21.025 20.1125 21.0125C19.8375 20.9875 19.5625 20.8625 19.3625 20.65L12.4125 13.7C12.9 13.3375 13.3375 12.9 13.7 12.4125L20.65 19.3625C20.85 19.5625 20.9875 19.8375 21.0125 20.1125C21.0125 20.2875 20.9875 20.55 20.775 20.775Z"
                            fill="black" />
                    </svg>
                </div>


            </ng-template>

            <ul class="max-h-[400px] overflow-y-auto">
                <li class="border-gray cursor-pointer" *ngFor="let item of items" (click)="chooseCustomer(item)">
                    <div class="customer_code text-black font-normal mb-[8px] mt-[6px] flex items-center gap-[8px]">
                        <span>{{ item.customerCode }}</span>
                        <span class="customer-status-badges flex items-center gap-[4px]">
                            <span *ngIf="item.blockStatusSales" class="customer-status-badge customer-status-sales" [attr.title]="'SALES_FREEZE' | translate">
                                <span class="status-text">{{'SALES_FREEZE' | translate}}</span>
                            </span>
                            <span *ngIf="item.deleted" class="customer-status-badge customer-status-deleted" [attr.title]="'DELETED' | translate">
                                <span class="status-text">{{'DELETED' | translate}}</span>
                            </span>
                        </span>
                    </div>
                    <div class="font-bold text-base text-black mb-[8px]">{{ item.customerName }}</div>
                </li>
            </ul>
        </div>
    </ng-template>

</div>